const CONFIG_DEFAULTS = {
  x: 0.1,
  y: 0.1,
  pad: 20,
  width: 600,
  height: 300,
  visible: false,
  fontSize: 18,
};

class DomLogger {
  constructor(game, scene, config = CONFIG_DEFAULTS, id) {
    this._game = game;
    this._scene = scene;
    this._config = config;
    this.id = id;
    const { width, height, visible, fontSize } = this._config;
    this.visible = visible;
    this.textAreaVisible = true;
    this.buttonSize = 40;

    const { tx, ty } = this.calculatePosition(this._game.viewportController);
    let style = `background-color: rgba(255, 255, 0, 0.5); width: ${width}px; height: ${height}px; font: ${fontSize}px Arial; font-weight: light; overflow-y: scroll; padding: 8px; box-sizing: border-box; border: 1px solid #ccc;`;
    this.textarea = this._scene.add.dom(tx, ty, 'textarea', style, '');

    let bx = tx - width * 0.5 - this.buttonSize * 0.5;
    let by = ty - height * 0.5 + this.buttonSize * 0.5;
    style = `background-color: rgba(255, 0, 0, 0.8); width: ${this.buttonSize}px; height: ${this.buttonSize}px; border: 1px solid #ccc;`;
    this.closeBtn = this._scene.add.dom(bx, by, 'button', style);
    this.closeBtn.addListener('click').on('click', () => {
      this.toggleVisibility();
    });

    by = by + this.buttonSize + 4;
    style = `background-color: rgba(255, 255, 0, 0.8); width: ${this.buttonSize}px; height: ${this.buttonSize}px; border: 1px solid #ccc;`;
    this.toggleBtn = this._scene.add.dom(bx, by, 'button', style);
    this.toggleBtn.addListener('click').on('click', () => {
      this.toggleTextAreaVisibility();
    });

    by = by + this.buttonSize + 4;
    style = `background-color: rgba(255, 128, 0, 0.8); width: ${this.buttonSize}px; height: ${this.buttonSize}px; border: 1px solid #ccc;`;
    this.copyBtn = this._scene.add.dom(bx, by, 'button', style);
    this.copyBtn.addListener('click').on('click', () => {
      this.copyToClipboard();
    });

    this.setLoggerVisibility(visible);
  }

  log(...args) {
    if (!this.textarea) {
      return;
    }
    const node = this.textarea.node;
    for (const arg of args) {
      node.value += `${arg}\n`;
    }
  }

  getLoggerVisibility() {
    return this.visible;
  }

  setLoggerVisibility(value) {
    this.visible = value;
    this.closeBtn.setVisible(this.visible);
    this.toggleBtn.setVisible(this.visible);
    this.copyBtn.setVisible(this.visible);
    this.textarea.setVisible(this.visible && this.textAreaVisible);
  }

  toggleTextAreaVisibility() {
    this.textAreaVisible = !this.textAreaVisible;
    this.textarea.setVisible(this.textAreaVisible);
  }

  toggleVisibility() {
    this.visible = !this.visible;
    this.textAreaVisible = true;
    this.closeBtn.setVisible(this.visible);
    this.toggleBtn.setVisible(this.visible);
    this.copyBtn.setVisible(this.visible);
    this.textarea.setVisible(this.visible);
  }

  copyToClipboard() {
    navigator.clipboard.writeText(this.textarea.node.value).then(
      () => {
        console.log('clipboard successfully set');
      },
      () => {
        console.error('clipboard write failed');
      }
    );
  }

  updatePosition() {
    const { tx, ty } = this.calculatePosition(this._game.viewportController);
    this.textarea.setPosition(tx, ty);
    const { x, y, pad, width, height } = this._config;
    let bx = tx - width * 0.5 - this.buttonSize * 0.5;
    let by = ty - height * 0.5 + this.buttonSize * 0.5;
    this.closeBtn.setPosition(bx, by);
    by = by + this.buttonSize + 4;
    this.toggleBtn.setPosition(bx, by);
    by = by + this.buttonSize + 4;
    this.copyBtn.setPosition(bx, by);
  }

  calculatePosition(viewport) {
    const gameWidth = viewport.width;
    const gameHeight = viewport.height;
    const offX = (this._game.defaultWidth - gameWidth) * 0.5;
    const { x, y, pad, width, height } = this._config;
    return {
      tx: Math.round(offX + x * (gameWidth - width - pad * 2) + width * 0.5 + pad),
      ty: Math.round(y * (gameHeight - height - pad * 2) + height * 0.5 + pad),
    };
  }

  destroy() {
    this._game = null;
    this._scene = null;
    this._config = null;
    this.textarea?.destroy();
    this.textarea = null;
    this.closeBtn?.destroy();
    this.closeBtn = null;
    this.toggleBtn?.destroy();
    this.toggleBtn = null;
    this.copyBtn?.destroy();
    this.copyBtn = null;
  }
}

export { DomLogger };
